export * from './base-palette.interface';
export * from './brand-palette.interface';
export * from './navbar-palette.interface';
export * from './palette.interface';
export * from './danger-button-palette.interfcae';
